import {
    GET_WHITE_LISTED_DEVICES,
    CREATE_WHITE_LISTED_DEVICE,
    EDIT_WHITE_LISTED_DEVICE,
    DELETE_WHITE_LISTED_DEVICE,
    OPEN_WHITE_LISTED_DEVICE_DIALOG,
    CLOSE_WHITE_LISTED_DEVICE_DIALOG,
} from "./types";

const initialState = {
    whiteListedDevices: [],
    dialog: false,
    dialogData: null,
};

const whiteListedDevicesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WHITE_LISTED_DEVICES:
            return {
                ...state,
                whiteListedDevices: action.payload,
            };
        case CREATE_WHITE_LISTED_DEVICE:
            const data = [...state.whiteListedDevices];
            data.unshift(action.payload);
            return {
                ...state,
                whiteListedDevices: data,
            };
        case EDIT_WHITE_LISTED_DEVICE:
            return {
                ...state,
                whiteListedDevices: state.whiteListedDevices.map((device) => {
                    if (device._id === action.payload.id) return action.payload.data;
                    else return device;
                }),
            };
        case DELETE_WHITE_LISTED_DEVICE:
            return {
                ...state,
                whiteListedDevices: state.whiteListedDevices.filter((device) => device._id !== action.payload),
            };
        case OPEN_WHITE_LISTED_DEVICE_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };
        case CLOSE_WHITE_LISTED_DEVICE_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };

        default:
            return state;
    }
};

export default whiteListedDevicesReducer;
